import { MEDIA_NOW_PREFIX, MEDIA_NOW_SUFFIX } from './videoUrlComm';

export const ALLETRA6k_VIDEO_URL = Object.freeze({
  UNBOX: MEDIA_NOW_PREFIX + 'PRPLOPKKDM&ek=H8xAFBhO' + MEDIA_NOW_SUFFIX,
  RACK_STEP1: MEDIA_NOW_PREFIX + 'KJQLNNGJHL&ek=NwdddPJU' + MEDIA_NOW_SUFFIX,
  RACK_STEP2: MEDIA_NOW_PREFIX + 'KJSOROFMGJ&ek=3iXuYhJi' + MEDIA_NOW_SUFFIX,
  RACK_STEP3: MEDIA_NOW_PREFIX + 'SQOSNKIHHK&ek=gvEVlvH7' + MEDIA_NOW_SUFFIX,
  CABLE: MEDIA_NOW_PREFIX + 'LRQPQKDDID&ek=L72yzEsD' + MEDIA_NOW_SUFFIX,
  POWER: MEDIA_NOW_PREFIX + 'PLPSJLJIHK&ek=cvtbBllL' + MEDIA_NOW_SUFFIX,
  DHCI_UNBOX: MEDIA_NOW_PREFIX + 'PRPLOPKKDM&ek=ItTR9ZrY' + MEDIA_NOW_SUFFIX,
  DHCI_RACK_ARRAY_STEP1: MEDIA_NOW_PREFIX + 'KJQLNNGJHL&ek=Z4pjASbV' + MEDIA_NOW_SUFFIX,
  DHCI_RACK_ARRAY_STEP2: MEDIA_NOW_PREFIX + 'KJSOROFMGJ&ek=RUBvrooc' + MEDIA_NOW_SUFFIX,
  DHCI_RACK_ARRAY_STEP3: MEDIA_NOW_PREFIX + 'SQOSNKIHHK&ek=W69FAgFL' + MEDIA_NOW_SUFFIX,
  DHCI_CABLE_ARRAY: MEDIA_NOW_PREFIX + 'LRQPQKDDID&ek=bgedmIpJ' + MEDIA_NOW_SUFFIX,
  DHCI_POWER: MEDIA_NOW_PREFIX + 'PLPSJLJIHK&ek=BaJinK7e' + MEDIA_NOW_SUFFIX,
  CONNECTARRAY: MEDIA_NOW_PREFIX + 'LRMPOSEKFF&ek=272I4fRG' + MEDIA_NOW_SUFFIX,
  SETUPARRAY: MEDIA_NOW_PREFIX + 'RJONMKIGJE&ek=FbOOJgao' + MEDIA_NOW_SUFFIX,
});
